module.exports = __webpack_public_path__ + "static/Growth-c22e4a8320c6b69e63b1697ae5f01dde.svg";